var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrashGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2153 3.93223C15.5071 3.93223 15.75 4.17447 15.75 4.48272V4.76772C15.75 5.06846 15.5071 5.31821 15.2153 5.31821H2.78539C2.49289 5.31821 2.25 5.06846 2.25 4.76772V4.48272C2.25 4.17447 2.49289 3.93223 2.78539 3.93223H4.97217C5.41639 3.93223 5.80298 3.61648 5.90291 3.17098L6.01743 2.65949C6.1954 1.96275 6.78112 1.5 7.45145 1.5H10.5485C11.2116 1.5 11.8039 1.96275 11.9753 2.62274L12.0978 3.17023C12.197 3.61648 12.5836 3.93223 13.0286 3.93223H15.2153ZM14.1044 14.3505C14.3327 12.2228 14.7324 7.16784 14.7324 7.11684C14.747 6.96235 14.6967 6.8161 14.5967 6.69835C14.4895 6.5881 14.3538 6.52285 14.2043 6.52285H3.80139C3.65113 6.52285 3.50817 6.5881 3.40897 6.69835C3.30831 6.8161 3.25871 6.96235 3.266 7.11684C3.26734 7.12621 3.28168 7.30428 3.30566 7.60197C3.41219 8.92441 3.70888 12.6076 3.90059 14.3505C4.03626 15.6345 4.87874 16.4415 6.09905 16.4708C7.04072 16.4925 8.01084 16.5 9.00284 16.5C9.93722 16.5 10.8862 16.4925 11.857 16.4708C13.1197 16.449 13.9614 15.6563 14.1044 14.3505Z",
    fill: "#959598"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashGray);
export default __webpack_public_path__ + "static/media/icon-trash-gray.7889958cd4c0afcea0f54e89a957147d.svg";
export { ForwardRef as ReactComponent };